export class GcpBigQueryDatasetRestoreResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "datasetId",
            "baseName": "datasetId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpBigQueryDatasetRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
